import { Link } from "react-router-dom";
import { nFormatter } from "@/common/utils/parseNumber";
import { routes } from "@/common/utils/routes";
import HashtagIcon from "./images/icons/hashtag.svg?react";
import "./TagCard.scss";
interface ITagCard {
  tagName: string;
  qty: number;
  highlightText?: React.ReactElement | string;
  onClick?: () => void;
}

export const TagCard = ({
  tagName,
  qty,
  highlightText,
  onClick
}: ITagCard) => {
  return (
    <Link to={routes.singleTag(tagName)} onClick={onClick} aria-label={`Link to ${tagName} tag`} className="tagCard">
      <div className="tagCardIcon"><HashtagIcon /></div>
      <div className="tagCardInfo">
        <span className="tagName">#{highlightText ?? tagName}</span>
        <span className="tagQty">{nFormatter(qty)} posts</span>
      </div>
    </Link>
  );
};
